import React from 'react';
import { LabelInput } from '@/components/ui/inputs';
import { PrimaryButton } from '@/components/ui/buttons/PrimaryButton';
import FormLayout from '@/components/layout/FormLayout';
import { PermissionGuard } from '@/components/layout';
import { PersonalEmailProvidersCard } from '@/components/features/employee/personalEmailProvidersCard';
import type { EmployeeProfile } from '@/api/domains/employee';


interface ContactDataFormProps {
  profile: EmployeeProfile | null;
  onCancel: () => void;
  contactForm: {
    register: any;
    handleSubmit: (e?: React.BaseSyntheticEvent) => Promise<void>;
    errors: any;
    isSubmitting: boolean;
  };
}

export const EmployeeProfileContactDataForm: React.FC<ContactDataFormProps> = ({
  profile,
  onCancel,
  contactForm,
}) => {
  const { register, handleSubmit, errors, isSubmitting } = contactForm;

  if (!profile) return null;

  return (
    <FormLayout onSubmit={handleSubmit} columns={4}>
      <FormLayout.Section title="Datos de contacto del colaborador">
        <LabelInput 
          label="Correo corporativo" 
          type="email" 
          registration={register('corporateEmail')}
          color={errors.corporateEmail ? 'error' : undefined}
          supportingText={errors.corporateEmail?.message}
        />
        <LabelInput 
          label="Correo personal" 
          type="email" 
          registration={register('personalEmail')}
          color={errors.personalEmail ? 'error' : undefined}
          supportingText={errors.personalEmail?.message}
        />
        <LabelInput 
          label="Teléfono corporativo" 
          registration={register('companyPhoneNumber')}
          color={errors.companyPhoneNumber ? 'error' : undefined}
          supportingText={errors.companyPhoneNumber?.message}
        />
        <LabelInput 
          label="Teléfono personal" 
          registration={register('personalPhoneNumber')}
          color={errors.personalPhoneNumber ? 'error' : undefined}
          supportingText={errors.personalPhoneNumber?.message}
        />
      </FormLayout.Section>

      <PersonalEmailProvidersCard />

      <FormLayout.Footer
        cancelButton={
          <PrimaryButton type="button" variant="outline" onClick={onCancel}>
            Cancelar
          </PrimaryButton>
        }
        primaryButton={
          <PermissionGuard action="edit">
            <PrimaryButton type="submit" isLoading={isSubmitting}>
              Guardar
            </PrimaryButton>
          </PermissionGuard>
        }
      />
    </FormLayout>
  );
};

export default EmployeeProfileContactDataForm;
